import { InputWrapper } from '../InputWrapper/InputWrapper';
import { TextFieldWithCounterProps } from '../input.interface';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { palette } from 'theme/palette';
import { TextField } from '../TextField/TextField';

const InputWrapperStyled = styled(InputWrapper)(({ theme }) => ({
  width: '100%',
  '& .clear-button': {
    position: 'absolute',
    right: 0,
    top: theme.spacing(2),
  },
  '& .textfield-error': {
    color: palette.error.contrastText,
  },
}));

const CounterBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  paddingRight: theme.spacing(10),
  transition: 'opacity 0.5s ease-out',
  opacity: 0,
  overflow: 'hidden',
})) as typeof Box;

export const TextFieldWithCounter: React.FC<TextFieldWithCounterProps> = ({
  label,
  fullWidth,
  onChange,
  value,
  maxLength,
  hidingCounter = true,
  ...props
}) => {
  const [isFocused, setIsFocused] = useState<boolean>(false);

  return (
    <InputWrapperStyled
      label={label}
      fullWidth={fullWidth}
      sx={{
        transition: 'height 0.5s ease-out',
        height: isFocused || !hidingCounter ? '64px !important' : '2.5rem !important',
      }}
    >
      <TextField
        value={(value as string) || ''}
        data-testid="Search textarea"
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        slotProps={{ htmlInput: { maxLength: maxLength } }}
        {...props}
      />
      <CounterBox
        component="span"
        sx={{
          opacity: isFocused || !hidingCounter ? 1 : 0,
          height: isFocused || !hidingCounter ? 'auto' : 0,
        }}
      >
        <Typography
          variant="text1"
          color="text.secondary"
          className={`${(value as string)?.length === maxLength ? 'textfield-error' : ''}`}
        >{`${(value as string)?.length || 0} / ${maxLength}`}</Typography>
      </CounterBox>
    </InputWrapperStyled>
  );
};
